<template>
  <div class="footer">
    <p>Copyright © 2020 sh-million.com All Rights Reserved</p>
    <a href="https://beian.miit.gov.cn/"
      >版权所有·上海米仑 沪ICP备2015606号-1</a
    >
    <p style="color: yellow; font-size: 16px">
      电话：
      <span style="color: yellow">021-56523831</span>
    </p>
    <p>地址：上海市宝山区高境镇共和新路4727号新陆国际商务大厦805室</p>
    <p>
      主营产品：KHK齿轮-KHK齿条-斜齿轮-锥齿轮-蜗轮蜗杆-齿轮箱-棘轮棘爪-行星齿轮结构组
    </p>
  </div>
</template>




<script>
export default {
  name: "mb-fotter",
};
</script>

<style scoped lang='less'>
.footer {
  background: #054183;
  position: relative;
  // bottom: -30px;
  left: 0;
  z-index: 10;
  width: 100%;
  // height: 1.6rem
  // margin: .8rem auto;
  padding: 0.3rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    margin: 0.16rem 0;
    color: #fcfdfd;
    font-size: 14px;
    line-height: 1;
  }

  a {
    margin: 0.16rem 0;
    color: #fcfdfd;
    font-size: 14px;
    line-height: 1;
    :hover {
      margin: 0.16rem 0;
      color: #fcfdfd;
      font-size: 14px;
      line-height: 1;
    }
  }
}
</style>
